import { render, staticRenderFns } from "./rangeInfo.vue?vue&type=template&id=1442a665&scoped=true"
import script from "./rangeInfo.vue?vue&type=script&lang=js"
export * from "./rangeInfo.vue?vue&type=script&lang=js"
import style0 from "./rangeInfo.vue?vue&type=style&index=0&id=1442a665&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1442a665",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1442a665')) {
      api.createRecord('1442a665', component.options)
    } else {
      api.reload('1442a665', component.options)
    }
    module.hot.accept("./rangeInfo.vue?vue&type=template&id=1442a665&scoped=true", function () {
      api.rerender('1442a665', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basicData/siteManagement/component/rangeInfo.vue"
export default component.exports